import React, { useEffect, useState } from "react";
// material
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  TextField,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Tooltip,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import WcOutlinedIcon from "@mui/icons-material/WcOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import FiberPinOutlinedIcon from "@mui/icons-material/FiberPinOutlined";
import MobileScreenShareIcon from "@mui/icons-material/MobileScreenShare";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LoadingButton } from "@mui/lab";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import {
  AcceptRejectAction,
  FetchUserDetailAction,
  BankVerificationUpdate,
  ResetBankVerificationUpdate,
} from "../redux/actions/UsersAction";
// components
import Label from "../components/Label";
import Page from "../components/Page";
import Iconify from "../components/Iconify";
import {
  CreditCardOff,
  PhoneDisabledOutlined,
  RemoveRedEye,
} from "@mui/icons-material";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import moment from "moment";

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string?.length; i += 1) {
    hash = string?.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}
function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(" ")[0][0]}`,
  };
}
export default function UserDetails() {
  const dispatch = useDispatch();

  let { id } = useParams();

  const [userModal, setUserModal] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState();
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [childOpen, setChildOpen] = useState(false);
  const [reject_reason, setRejectReason] = useState("");
  const [userType, setUserType] = useState(localStorage.getItem("usertype"));
  const bankVerifySelector = useSelector((state) => state.users.bank_verify);

  const userDetailState = useSelector(
    (state) => state.users?.user_detail?.data?.data
  );

  const UserDetail = userDetailState !== undefined && userDetailState;
  useEffect(() => {
    dispatch(FetchUserDetailAction({ userid: id }));
  }, [dispatch, id, count]);

  const confirmationModalOpen = (value) => {
    setUserModal(true);
    setVerificationStatus(value);
  };
  const confirmationModalClose = () => {
    setUserModal(false);
  };
  const AcceptReject = (e) => {
    // setVerificationStatus(1);
    dispatch(
      AcceptRejectAction({
        id,
        status: verificationStatus,
      })
    );
    setUserModal(false);
    setTimeout(() => {
      setCount(count + 1);
    }, 500);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "15px",
  };

  const Confirmstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "400px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "15px",
    textAlign: "center",
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    dispatch(ResetBankVerificationUpdate());
  };

  const handleBankStatus = (status) => {
    if (status == 3) {
      setChildOpen(true);
    } else {
      dispatch(
        BankVerificationUpdate({
          userid: UserDetail.id,
          isverified: status,
        })
      );
    }
  };
  const onClickCancelRequest = (status) => {
    dispatch(
      BankVerificationUpdate({
        userid: UserDetail.id,
        isverified: 3,
        reject_reason: reject_reason,
      })
    );
    handleChildClose();
    //  setOpen(false);
  };

  const handleChildClose = () => {
    setChildOpen(false);
  };
  useEffect(() => {
    if (Object.keys(bankVerifySelector).length > 0) {
      if (bankVerifySelector.data.status) {
        setOpen(false);
        dispatch(ResetBankVerificationUpdate());
        dispatch(FetchUserDetailAction({ userid: id }));
      }
    }
  }, [bankVerifySelector]);

  const dateFormat = (tempDob) => {
    const dataSet =
      tempDob.toString().length < 8 ? "0" + tempDob : "" + tempDob;
    return moment(dataSet, "DDMMYYYY").format("DD/MM/YYYY");
  };

  return (
    <Page title="User">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        size="lg"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            style={{ marginBottom: 20 }}
            align={"center"}
            variant="h6"
            component="h2"
          >
            {" "}
            Bank Details{" "}
          </Typography>
          <Divider />
          <TableContainer fullWidth>
            <Table>
              <TableBody>
              

                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    Account Holder Name{" "}
                  </TableCell>
                  <TableCell align="left">
                    {" "}
                    {UserDetail?.userbank_account?.acholdername
                      ? UserDetail?.userbank_account?.acholdername
                      : "-"}{" "}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    Bank Name{" "}
                  </TableCell>
                  <TableCell align="left">
                    {" "}
                    {UserDetail?.userbank_account?.bankname
                      ? UserDetail?.userbank_account?.bankname
                      : "-"}{" "}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    Account Number{" "}
                  </TableCell>
                  <TableCell align="left">
                    {" "}
                    {UserDetail?.userbank_account?.acno
                      ? UserDetail?.userbank_account?.acno
                      : "-"}{" "}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    IFSC Code{" "}
                  </TableCell>
                  <TableCell align="left">
                    {" "}
                    {UserDetail?.userbank_account?.ifsccode
                      ? UserDetail?.userbank_account?.ifsccode
                      : "-"}{" "}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    UPI ID{" "}
                  </TableCell>
                  <TableCell align="left">
                    {" "}
                    {UserDetail?.userbank_account?.upi
                      ? UserDetail?.userbank_account?.upi
                      : "-"}{" "}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    Bank Image{" "}
                  </TableCell>
                  <TableCell align="left">
                    <img
                      src={
                        UserDetail?.userbank_account?.image
                          ? UserDetail?.userbank_account?.image
                          : "/no_image.png"
                      }
                      className="img-fluid"
                      alt={UserDetail?.userbank_account?.acholdername}
                      width="200"
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          {UserDetail.isbankdverify !== 1 && UserDetail.isbankdverify !== 3 ? (
            <div
              style={{
                marginTop: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                color="success"
                onClick={() => handleBankStatus(1)}
              >
                Verify
              </Button>
              <Button
                variant="contained"
                color="error"
                style={{ marginLeft: 10 }}
                onClick={() => handleBankStatus(0)}
              >
                Cancel Request
              </Button>
            </div>
          ) : null}
        </Box>
      </Modal>

      <Modal
        open={childOpen}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style, width: 500 }}>
          <h2 id="child-modal-title">Are you sure, you want to Reject ?</h2>
          <p id="child-modal-description">
            <TableContainer fullWidth>
              <Table>
                <TableBody>
                  <TextField
                    required
                    onChange={({ target }) => setRejectReason(target.value)}
                    value={reject_reason}
                    style={{ marginTop: 20, width: "100%" }}
                    id="outlined-basic"
                    label="Reason For Reject"
                    variant="outlined"
                    type="text"
                    inputProps={{ maxLength: 200 }}
                  />
                </TableBody>
              </Table>
            </TableContainer>
          </p>
          <div
            style={{
              marginTop: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button onClick={handleChildClose}>Close</Button>
            <Button
              variant="contained"
              onClick={(e) => onClickCancelRequest(4)}
            >
              Cancel Request
            </Button>
          </div>
        </Box>
      </Modal>

      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="User Details"
          links={[
            { name: "Dashboard", href: "/dashboard/app" },
            { name: "User Details" },
          ]}
        />

        <Card spacing={2}>
          <CardContent sx={{ display: "flex", alignItems: "center" }}>
            {UserDetail?.user_profile?.name ? (
              <Avatar
                {...stringAvatar(UserDetail?.user_profile?.name)}
                sx={{
                  width: 100,
                  height: 100,
                  fontSize: 40,
                  textTransform: "uppercase",
                }}
              />
            ) : (
              <img
                src="/static/default-user-icon.svg"
                className="img-fluid"
                width="100"
                height="100"
              />
            )}

            <CardContent sx={{ pl: 3, flex: "1 0 auto" }}>
              <Typography gutterBottom variant="h4" component="div">
                {UserDetail.first_name} {UserDetail.middle_name}
                {UserDetail.last_name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <span style={{ marginBottom: "10px", display: "block" }}>
                  ID:{UserDetail.id}
                </span>
                {UserDetail?.status === 1 ? (
                  <Label variant="ghost" color={"success"}>
                    Active
                  </Label>
                ) : (
                  <Label variant="ghost" color={"error"}>
                    Inactive
                  </Label>
                )}
              </Typography>
            </CardContent>
            {userType==3 && <CardContent sx={{}}>
              <div className="custom-btn-group">
                {UserDetail.status === 1 ? (
                  <Button
                    variant="contained"
                    onClick={() => confirmationModalOpen(2)}
                    color="error"
                  >
                    <Iconify
                      icon="clarity:close-line"
                      sx={{ mr: 0.5 }}
                      width={20}
                      height={20}
                    />
                    Inactive
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    onClick={() => confirmationModalOpen(1)}
                    color="success"
                  >
                    <Iconify icon="teenyicons:tick-solid" sx={{ mr: 0.5 }} />
                    Active
                  </Button>
                )}
              </div>
            </CardContent>}
          </CardContent>
          <Divider />
          <CardContent>
            {userType==3 && <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h5" component="div" sx={{ mb: 2 }}>
                  Personal Details
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <List>
                      <ListItem sx={{ p: 0 }}>
                        <ListItemIcon className="ud-icon" sx={{ minWidth: 40 }}>
                          <Iconify
                            icon="carbon:user-avatar-filled-alt"
                            width={24}
                            height={24}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary="Name"
                          secondary={
                            UserDetail?.user_profile?.name
                              ? UserDetail?.user_profile?.name
                              : "--"
                          }
                        />
                      </ListItem>
                    </List>
                    <Divider />
                  </Grid>
                  <Grid item xs={6}>
                    <List>
                      <ListItem sx={{ p: 0 }}>
                        <ListItemIcon className="ud-icon" sx={{ minWidth: 40 }}>
                          <Iconify
                            icon="dashicons:email-alt"
                            width={24}
                            height={24}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary="Email"
                          secondary={UserDetail.email ? UserDetail.email : "--"}
                        />
                      </ListItem>
                    </List>
                    <Divider />
                  </Grid>
                  <Grid item xs={6}>
                    <List>
                      <ListItem sx={{ p: 0 }}>
                        <ListItemIcon className="ud-icon" sx={{ minWidth: 40 }}>
                          <Iconify
                            icon="bi:phone-vibrate-fill"
                            width={24}
                            height={24}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary="Phone"
                          secondary={UserDetail.phone ? UserDetail.phone : "--"}
                        />
                      </ListItem>
                    </List>
                    <Divider />
                  </Grid>
                  <Grid item xs={6}>
                    <List>
                      <ListItem sx={{ p: 0 }}>
                        <ListItemIcon className="ud-icon">
                          <CalendarMonthOutlinedIcon width={24} height={24} />
                        </ListItemIcon>
                        <ListItemText
                          primary="Date of birth"
                          secondary={
                            UserDetail.user_profile?.dob
                              ? dateFormat(UserDetail.user_profile?.dob)
                              : "--"
                          }
                        />
                      </ListItem>
                    </List>
                    <Divider />
                  </Grid>
                </Grid>
              </Grid>
              <Divider />
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <MobileScreenShareIcon width={24} height={24} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Refer Code"
                      secondary={
                        UserDetail.refercode ? UserDetail.refercode : "--"
                      }
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <WcOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Gender"
                      secondary={
                        UserDetail.user_profile?.gender
                          ? UserDetail.user_profile?.gender
                          : "--"
                      }
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <HomeOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Address"
                      secondary={
                        UserDetail.user_profile?.address
                          ? UserDetail.user_profile?.address
                          : "--"
                      }
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <LanguageOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="City"
                      secondary={
                        UserDetail.user_profile?.cityid
                          ? UserDetail.user_profile?.cityid
                          : "--"
                      }
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <LocationCityOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="State"
                      secondary={
                        UserDetail.user_profile?.stateid
                          ? UserDetail.user_profile?.stateid
                          : "--"
                      }
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <PublicOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Country"
                      secondary={UserDetail.country ? "UK" : "IN"}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <FiberPinOutlinedIcon fontSize="large" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Pin Code"
                      secondary={
                        UserDetail.user_profile?.pincode
                          ? UserDetail.user_profile?.pincode
                          : "--"
                      }
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>
              <Divider />
            </Grid>}
            {userType==3 && <Typography variant="h5" component="div" sx={{ mt: 4, mb: 2 }}>
              Wallet Details
            </Typography>}
            {userType==3 && <Grid container spacing={2}>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CurrencyRupeeIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Wallet Balance"
                      secondary={UserDetail.walletbalance}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CurrencyRupeeIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Wallet Bonus"
                      secondary={UserDetail.wltbns}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CurrencyRupeeIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Welcome Bonus"
                      secondary={UserDetail.welbns}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CurrencyRupeeIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Wallet Deposit"
                      secondary={UserDetail.wltdept ? UserDetail.wltdept : 0}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CurrencyRupeeIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Total Deposit TDS"
                      secondary={
                        UserDetail.totaltds
                          ? UserDetail.totaltds.toFixed(2)
                          : 0.0
                      }
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CurrencyRupeeIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Current TDS Remaining"
                      secondary={
                        UserDetail.wltbaltds
                          ? UserDetail.wltbaltds.toFixed(2)
                          : 0.0
                      }
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CurrencyRupeeIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Withdrawal Amount"
                      secondary={
                        UserDetail.wltwithdraw
                          ? UserDetail.wltwithdraw.toFixed(2)
                          : 0.0
                      }
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CurrencyRupeeIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Total GST"
                      secondary={
                        UserDetail.gst ? UserDetail.gst.toFixed(2) : 0.0
                      }
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CurrencyRupeeIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Wallet Win Amount"
                      secondary={UserDetail.wltwin}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CurrencyRupeeIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Number of deposits"
                      secondary={UserDetail?.TotalDeposit}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CurrencyRupeeIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Number of withdrawals"
                      secondary={UserDetail?.TotalWithdrawal}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>
            </Grid>}
            <Typography variant="h5" component="div" sx={{ mt: 4, mb: 2 }}>
              Contests & Accumulator Details
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemText
                      primary="Total Contests"
                      secondary={UserDetail.totalContests}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemText
                      primary="Contests Won"
                      secondary={UserDetail.contestsWon}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemText
                      primary="Total Player Accumulator"
                      secondary={UserDetail.plyAccCount}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemText
                      primary="Player Accumulator Won"
                      secondary={UserDetail.plyAccWon}
                    />
                  </ListItem>
                </List>
                <Divider />
              </Grid>
            </Grid>

            {userType==3 && <Typography variant="h5" component="div" sx={{ mt: 4, mb: 2 }}>
              Verification Details
            </Typography>}
            {userType==3 && <Grid container spacing={2}>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CreditCardIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Email Verify"
                      secondary={
                        UserDetail.isemailverify === 1
                          ? "Verified"
                          : "Not Verified"
                      }
                    />
                    <Grid sx={{ display: "flex" }}>
                      <Typography></Typography>
                      {UserDetail.isemailverify ? (
                        <Tooltip title="Email Verified">
                          <MarkEmailReadIcon color="success" />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Email Not verified">
                          <EmailIcon color="error" />
                        </Tooltip>
                      )}
                      {/* <Button onClick={handleOpen}>
                                                <RemoveRedEye color="primary" />
                                            </Button> */}
                    </Grid>
                  </ListItem>
                </List>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CreditCardIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Pan card"
                      secondary={
                        UserDetail.ispanverify === 1
                          ? "Verified"
                          : "Not Verified"
                      }
                    />
                    <Grid sx={{ display: "flex" }}>
                      {UserDetail.ispanverify ? (
                        <Tooltip title="Pan Verified">
                          <CreditCardIcon color="success" />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Pan Not verified">
                          <CreditCardOff color="error" />
                        </Tooltip>
                      )}
                      {/* <Button onClick={handleOpen}>
                                                <RemoveRedEye color="primary" />
                                            </Button> */}
                    </Grid>
                  </ListItem>
                </List>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CreditCardIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Bank Verified"
                      secondary={
                        UserDetail.isbankdverify === 1
                          ? "Verified"
                          : UserDetail.isbankdverify === 2
                          ? "Pending Verification"
                          : "Not Verified"
                      }
                    />
                    <Grid sx={{ display: "flex" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {UserDetail.isbankdverify === 1 ? (
                          <Tooltip title="Bank Verified">
                            <AccountBalanceIcon color="success" />
                          </Tooltip>
                        ) : UserDetail.isbankdverify === 2 ? (
                          <Tooltip title="Bank verification pending">
                            <AccountBalanceIcon color="warning" />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Bank Not Verified">
                            <AccountBalanceIcon color="error" />
                          </Tooltip>
                        )}
                        
                          <div style={{ marginLeft: 10 }}>
                            <Button onClick={handleOpen}>
                              <RemoveRedEye color="primary" />
                            </Button>
                          </div>
                           {/* {UserDetail?.userbank_account ? (
                          <div style={{ marginLeft: 10 }}>
                            <Button onClick={handleOpen}>
                              <RemoveRedEye color="primary" />
                            </Button>
                          </div>
                          
                        ) : null} */}
                        
                      </div>
                    </Grid>
                  </ListItem>
                </List>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <List>
                  <ListItem sx={{ p: 0 }}>
                    <ListItemIcon className="ud-icon">
                      <CreditCardIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Phone Verified"
                      secondary={
                        UserDetail.isphoneverify === 1
                          ? "Verified"
                          : "Not Verified"
                      }
                    />
                    <Grid sx={{ display: "flex" }}>
                      {UserDetail.isphoneverify ? (
                        <Tooltip title="Phone Verified">
                          <LocalPhoneIcon color="success" />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Phone Not verified">
                          <PhoneDisabledOutlined color="error" />
                        </Tooltip>
                      )}
                      {/* <Button onClick={handleOpen}>
                                                <RemoveRedEye color="primary" />
                                            </Button> */}
                    </Grid>
                  </ListItem>
                </List>
                <Divider />
              </Grid>
            </Grid>}
          </CardContent>
        </Card>
      </Container>

      <Modal
        open={userModal}
        onClose={confirmationModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={Confirmstyle}>
          <Typography
            id="modal-modal-title"
            variant="h3"
            component="h2"
            sx={{ mb: 0 }}
          >
            Confirmation
          </Typography>
          <Typography id="modal-modal-description" sx={{ mb: 3 }}>
            Are you sure you want to do this?
          </Typography>
          <div className="custom-btn-group text-center">
            <Button
              variant="contained"
              color="error"
              onClick={confirmationModalClose}
            >
              <Iconify
                icon="clarity:close-line"
                sx={{ mr: 0.5 }}
                width={20}
                height={20}
              />
              Cancel
            </Button>
            <LoadingButton
              variant="contained"
              onClick={() => AcceptReject(verificationStatus)}
              color="success"
              loading={false}
            >
              <Iconify icon="teenyicons:tick-solid" sx={{ mr: 0.5 }} /> Submit
            </LoadingButton>
          </div>
        </Box>
      </Modal>
    </Page>
  );
}
